import {toNavigatorMap} from '../../../compatibility.mjs'
import apiMap from '../../../apis/apiMap.mjs'

export const saveMap = () => {
    return () => async function () {
        const {data} = this
        const _n = this.nodeProxy(this.root)
        const compact = 'UI_MAP' !== this.data.mapTypeCode
        const root = _n.exportTree({compact})
        const mapModel = toNavigatorMap({data, root})

        const {
            mapModel: dummy,
            ...newData
        } = await apiMap.save({...this.data, mapModel})

        this.data = {...this.data, ...newData}
    }
}
